import * as mat4 from '../math/mat4';
import { Transformable } from './Transformable';
export class Camera extends Transformable {
    constructor(fov) {
        super();
        this.w = 0;
        this.h = 0;
        this.zoom = 1;
        this.gamma = 1;
        this.brightness = 0;
        this.contrast = 1;
        this.initialize(fov);
    }
    initialize(fov) {
        this.projectionMatrix = mat4.create();
        this.fov = fov;
        this.projectionMatrix = mat4.orthoZO(this.projectionMatrix, 0, fov.width, fov.height, 0, 0, 1);
        this.viewMatrix = mat4.create();
        this.w = fov.width;
        this.h = fov.height;
    }
    resize(fov) {
        this.initialize(fov);
    }
    move(x, y) {
        this.transform.position.x = x;
        this.transform.position.y = y;
        this.fov.left = x;
        this.fov.top = y;
        this.viewMatrix = mat4.create();
        this.viewMatrix = mat4.translate(this.viewMatrix, this.viewMatrix, [
            -x,
            -y,
            0
        ]);
        this.viewMatrix = mat4.translate(this.viewMatrix, this.viewMatrix, [
            x + this.fov.width * 0.5,
            y + this.fov.height * 0.5,
            0
        ]);
        this.viewMatrix = mat4.rotateZ(this.viewMatrix, this.viewMatrix, this.transform.rotation.z);
        this.viewMatrix = mat4.translate(this.viewMatrix, this.viewMatrix, [
            -(x + this.fov.width * 0.5),
            -(y + this.fov.height * 0.5),
            0
        ]);
        this.viewMatrix = mat4.scale(this.viewMatrix, this.viewMatrix, [
            this.zoom,
            this.zoom,
            0
        ]);
    }
}
//# sourceMappingURL=Camera.js.map